import Picker from "../picker/picker";

let timeout = null;

function handshakeListener(event) {

    // the tag in the tab will respond with lytics_handshake: true.  when we get that we can stop the loop
    if ("lytics_handshake" in event.data && event.data.lytics_handshake && timeout != null) {
        console.log("Got handshake")
        clearInterval(timeout);
        timeout = null;
    }
}

window.addEventListener("message", handshakeListener);


// for getting authentication details
function getCookies() {
    return document.cookie.split('; ').reduce((prev, current) => {
        const [name, ...value] = current.split('=');
        prev[name] = value.join('=');
        return prev;
    }, {});
}

function go(url) {

    // open tab
    const tab = window.open(url, '_blank');
    tab.focus();

    // we'll pass these properties to the window
    let queryProperties = {
        "start": Picker.start_YYYYMMDDHHmmss(),
        "end": Picker.end_YYYYMMDDHHmmss(),
        "timezone": Picker.timezone()
    };

    // get propertyId from path
    let match = window.location.pathname.match(/^\/account\/view\/([0-9]+)\/.*$/);
    let propertyId = match[1];

    // get authentication details that we pass along.  they might not exist if the stats are made public
    let cookies = getCookies();
    let sid = cookies["sid"];
    let svalue32 = null;
    if (cookies["svalue"] != null)
        svalue32 = cookies["svalue"].substring(0, 32); // we only pass along half the svalue for security

    // import.meta.url will be something like /static/bundle/main-XTJYU6BK.js, and the hash suffix will change each time we deploy new
    // offsite code. adding import.meta.url to the url acts as a cache buster when we deploy new offsite code
    const injectionScript = `${window.location.origin}/static/offsite/offsite.min.js?from=${encodeURIComponent(import.meta.url)}`;

    const injectionData = {
        "injectScript": injectionScript,
        "origin": window.location.origin,
        "propertyId": propertyId,
        "queryProperties": queryProperties,
    };

    // only set these if they are defined
    if (sid)
        injectionData["sid"] = sid;
    if (svalue32)
        injectionData["svalue32"] = svalue32;


    timeout = setInterval(function () {
        // keep on trying to establish contact with the new tab. we'll do this until we get a response
        tab.postMessage(injectionData, "*");
    }, 100);
}

function installClickHandler(doc) {
    Array
        .from(doc.querySelectorAll(".heatmap-link"))
        .forEach(heatmapLink => {
            heatmapLink.onclick = function(evt) {
                let url = heatmapLink.getAttribute("data-url");
                HeatmapLink.go(url);
            }
        });
}

const HeatmapLink = {
    "go": go,
    "installClickHandler": installClickHandler
};

export default HeatmapLink;